import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=c7fc9272&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryTab.vue?vue&type=style&index=0&id=c7fc9272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fc9272",
  null
  
)

export default component.exports